// removed by extract-text-webpack-plugin
module.exports = {"section":"_1c743ba9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PaymentAccountFormLoader/styles.module.styl
// module id = 5215
// module chunks = 39